import { createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from 'lodash';

const selectorList = [];

function defaultEqualityCheck(previousVal, currentVal) {
  // const result = isEqual(previousVal, currentVal);
  const result = previousVal === currentVal;
  // if (result !== resultNat) {
  //   console.log('reselect: ', previousVal, currentVal);
  // }
  return result;
}

export const createSelectorFunc = createSelectorCreator(defaultMemoize, {
  maxSize: 8,
  equalityCheck: defaultEqualityCheck,
  resultEqualityCheck: defaultEqualityCheck,
});

export const createSelector: typeof createSelectorFunc = (selectors, resultFunc, options) => {
  const selector = createSelectorFunc(selectors, resultFunc);
  selectorList.push(selector);
  return selector;
};

export const lodashMemoize = { memoizeOptions: { equalityCheck: isEqual } };

const isBrowser = typeof window === 'object';

if (isBrowser) {
  // @ts-ignore
  window.reselectDebugNew = () => {
    let res = 0;
    selectorList.forEach((selector) => {
      try {
        res += selector.recomputations();
      } catch {}
    });
    return res;
  };
}
